// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"14093221","256":"bd35cfd6","589":"23e7490c"}[chunkId] + ".chunk.js";
};